// import initialState from '../store/initialState';
import { Types } from '../actions/actionTypes';
import initialState from '../store/initialState'


export const setEnvReducer = (state = initialState.setEnv, action) => {
    console.log("set env reducer------->", action)
    switch (action.type) {
        case Types.SET_ENV:
            console.log("setting SetEnv reducer---------->", action.payload)
            return {
                ...state,
                env: action.payload
            };

        default:
            return state;
    };


};